import React from 'react';
export function MeetTheTeam() {
  const team = [{
    name: 'Lucy Hayhurst',
    role: 'RD, LDN',
    specialty: ''
  }, {
    name: 'Kristen Norton',
    role: 'RD, LDN',
    specialty: ''
  }, {
    name: 'Christy Quirk',
    role: 'MS, RD, LDN',
    specialty: ''
  }, {
    name: 'Bridget Hollingsworth',
    role: 'RD, LDN',
    specialty: ''
  }, {
    name: 'Joann Godwin',
    role: 'RD, LDN, CPG',
    specialty: ''
  }];
  return <section className="py-24 bg-white" data-id="element-104">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <h2 className="font-serif text-3xl font-bold text-stone-900 sm:text-4xl" data-id="element-107">
            Meet Your Coaches
          </h2>
          <p className="mt-4 text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-108">
            We are a team of licensed professionals who believe in kindness,
            science, and sustainable change.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10" data-id="element-109">
          {team.map((member, i) => <div key={i} className="flex flex-col items-center text-center group" data-id="element-110">
              <div className="relative mb-6" data-id="element-111">
                <div className="h-40 w-40 rounded-full bg-stone-200 overflow-hidden border-4 border-white shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-112">
                  {/* Placeholder for team photo */}
                  <div className="h-full w-full bg-stone-300 flex items-center justify-center text-stone-500" data-id="element-113">
                    <span className="text-2xl font-serif" data-id="element-114">
                      {member.name[0]}
                    </span>
                  </div>
                </div>
                <div className="absolute bottom-0 right-0 text-xs font-bold px-3 py-1 rounded-full border-2 border-white text-white" style={{
              backgroundColor: '#4bc041'
            }} data-id="element-115">
                  {member.role}
                </div>
              </div>
              <h3 className="text-lg font-bold text-stone-900" data-id="element-116">
                {member.name}
              </h3>
              <p className="text-sm text-stone-500 mt-1" data-id="element-117">{member.specialty}</p>
            </div>)}
        </div>
      </div>
    </section>;
}